export const OTP_SENT_MESSAGE = 'LOGIN_SUCCESS_OTP_SENT';
